export class SharedService {

  /**
   * 각 운동카테고리 컬러
   */
  static setEcColor(ecname: string): string {
    const color: string = ecname === '소뇌통합' ?
      'ecname-smallbrain' : ecname === '안구조절' ?
      'ecname-eye' : ecname === '감각' ?
      'ecname-feel' : ecname === '보행교차' ?
      'ecname-walk' : ecname === '근육발달' ?
      'ecname-muscle' : ecname === '계획실행' ?
      'ecname-plan' : ecname === '공간방향' ?
      'ecname-space' : '';
    return color;
  }

  /**
   * 운동카테고리에 따른 운동 컬러
   */
  static setEColor(ecname: string): string {
    const color = ecname === '소뇌통합' ?
      'ename-smallbrain' : ecname === '안구조절' ?
      'ename-eye' : ecname === '감각' ?
      'ename-feel' : ecname === '보행교차' ?
      'ename-walk' : ecname === '근육발달' ?
      'ename-muscle' : ecname === '계획실행' ?
      'ename-plan' : ecname === '공간방향' ?
      'ename-space' : '';
    return color;
  }

    /**
   * 각 운동의 뇌 설명 컬러
   */
  static setBrainColor(brainName: string): string {
    const color = brainName === '전두엽' ?
      'brain-frontal' : brainName === '두정엽' ?
      'brain-pariental' : brainName === '후두엽' ?
      'brain-occipical' : brainName === '측두엽' ?
      'brain-temporal' : brainName === '소뇌' ?
      'brain-cerebellum' : brainName === '뇌간' ?
      'brain-stem' : '';
    return color;
  }

  /**
   * 각 운동의 화살표 이미지
   * 소뇌, 안구, 감각(X), 보행, 근육 계획, 공간, 검사
   */
  static setArrowColor(ecNum: number, eNum: number): string {
    const src = 'assets/images/exercise_icon_0';
    const num = (ecNum === 5 || ecNum === 11 || ecNum === 17 || eNum ===  85) ?
      1 : (ecNum === 1 || ecNum === 7 || ecNum === 13) ?
      2 : (ecNum === 24) ?
      3 : (ecNum === 3 || ecNum === 9 || ecNum === 15 || eNum === 74) ?
      4 : (ecNum === 2 || ecNum === 8 || ecNum === 14 || eNum === 68) ?
      5 : (ecNum === 6 || ecNum === 12 || ecNum === 18 || eNum === 90) ?
      6 : (ecNum === 4 || ecNum === 10 || ecNum === 16 || eNum === 80) ?
      7 : (eNum === 67 || eNum === 73 || eNum === 79 || eNum === 84 || eNum === 89) ?
      8 : 1;

    return `${src}${num}.png`;
  }

  /**
   * 정수가 10 미만, 0 이상이면 '0' 추가
   * @param {number} n 입력값
   * @returns string 10미만이면 0n, 아니면 n
   */
  public static addZero(n: number): string {
    return n < 10 && n >= 0 ? '0' + n : '' + n;
  }
}
